export class CentreManagementFeeModel {
	public id: string;
  public description: string;
  public rate : Float32Array;
  public centreId: string;
  public centreName: string;
  public centreIds: string[];
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/master-data/centre-management-fee.model.ts